import config from '../../config';
import { apiFetch, createMultiConsumerGet } from './apiFetch';

// Identical reads in flight share one request (request deduplication).
const sharedGet = createMultiConsumerGet(async (url, options) => {
    const res = await apiFetch(url, options);
    const body = await res.json().catch(() => null);
    if (!res.ok) throw new Error((body && body.error) || `HTTP ${res.status}`);
    return body;
});

// Newest first, paged. The server scopes rows to the logged-in user's company.
// Optional filters: from, to (timestamps), action, jobNo. Empty ones are left out.
export const getPlanningAuditLog = (query = {}, options = {}) => {
    const params = new URLSearchParams();
    Object.entries({ page: 1, limit: 50, ...query }).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') params.set(key, value);
    });
    return sharedGet(`${config.apiUrl}/getPlanningAuditLog?${params}`, options);
};
